import React from 'react';

import { Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

export const NotificationLabel = ({ notification }) => {
  let text;

  switch (notification.notification_type.notification_type) {
    case 'email':
      text = `Email`;
      break;
    case 'slack':
      text = `Slack`;
      break;
    case 'sms':
      text = `SMS`;
      break;
    case 'voice':
      text = `Voice`;
      break;
    case 'whats_app':
      text = `WhatsApp`;
      break;
    case 'apns':
      text = `iOS`;
      break;
    case 'fcm':
      text = `Android`;
      break;
    case 'microsoft_teams':
      text = `Teams`;
      break;
    default:
      text = null;
  }

  return (
    <Text mb="0" color="content.primary" textStyle="body1" isTruncated>
      {text}
    </Text>
  );
};

NotificationLabel.propTypes = {
  notification: PropTypes.shape({
    notification_type: PropTypes.shape({
      notification_type: PropTypes.string,
    }),
  }).isRequired,
};
